<div
	class="address-bar-container"
	[class.has-label]="label"
	[class.is-full-width]="fullWidth"
>
	<div
		class="address-bar-container_inner-container"
		[class.container]="fullWidth"
	>
		<div class="label" *ngIf="label">{{ label }}</div>
		<div class="address-container">
			<div class="address">
				<span class="address-icon">
					<img src="../assets/img/icons/icon-map-pin.svg" />
				</span>
				<span class="address-label">{{ address }}</span>
			</div>
			<div class="address-change-link-container">
				<a (click)="changeAddress()">Change</a>
			</div>
		</div>
	</div>
</div>
